import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";

export default {
  namespaced: true,
  state: {
    showThankYou: false,
  },
  getters: {
    getShowThankYouModal(state) {
      return state.showThankYou;
    },
  },
  mutations: {
    updateShowThankYouModal(state, payload) {
      state.showThankYou = payload;
    },
  },
  actions: {},
};
